export const c_multiple_file_upload_m_horizontal__main_GridTemplateAreas = {
  "name": "--pf-c-multiple-file-upload--m-horizontal__main--GridTemplateAreas",
  "value": "\"title upload\"\n    \"info upload\"",
  "var": "var(--pf-c-multiple-file-upload--m-horizontal__main--GridTemplateAreas)"
};
export default c_multiple_file_upload_m_horizontal__main_GridTemplateAreas;